import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ApiRoutes} from "../../../config/api-routes";

@Injectable()
export class SpfRecordService {

  constructor(
    private httpClient: HttpClient,
    private api: ApiRoutes,
  ) { }

  public get all(): Observable<SpfRecord[]> {
    return this.httpClient.get<SpfRecord[]>(
      this.api.BUSINESS_SPF_RECORDS
    );
  }

  save(record: SpfRecord) {
    const action: CreateOrUpdate = Number.isFinite(record.businessSpfRecordId) ? 'put' : 'post';
    return this.httpClient[action]<SpfRecord>(
      this.api.BUSINESS_SPF_RECORDS,
      record
    );
  }

  delete(record: SpfRecord) {
    return this.httpClient.delete(
      this.api.getRouteWithInjectedParams(this.api.BUSINESS_SPF_RECORD, [`${record.businessSpfRecordId}`])
    );
  }
}

export interface SpfRecord {
  businessSpfRecordId: number;
  businessId: number;
  dnsName: string;
  isValid: boolean;
}

type CreateOrUpdate = keyof Pick<HttpClient, 'put' | 'post'>;
